import { useState, useContext, useEffect } from "react";
import { Backdrop, Box, CircularProgress } from "@mui/material";

import { IGlobarProps } from "../interfaces";
import DesktopView from "../views/searchUsers/desktop";
import MobileView from "../views/searchUsers/mobile";
import { AppContext } from "../context";
import {
  NavigateFunction,
  Params,
  useNavigate,
  useParams,
} from "react-router-dom";
import myAppApi from "../api";
import { User } from "../types";

const SearchUsers: React.FC<IGlobarProps> = ({ isMobile }) => {
  const { state, handleLoading } = useContext(AppContext);
  const params: Params = useParams();
  const [users, setUsers] = useState<User[]>([]);
  const navigate: NavigateFunction = useNavigate();

  const getUsers = async (): Promise<void> => {
    handleLoading(true);
    try {
      const response = (await myAppApi.get(`/users/find/${params.query}`)).data;
      setUsers(response.users);
    } catch (err) {
      console.log(err);
    }
    handleLoading(false);
  };

  const goToProfile = (id: string) =>
    id === state.user?._id ? navigate(`/profile`) : navigate(`/profile/${id}`);

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <Box>
      {isMobile ? (
        <MobileView
          state={state}
          isMobile={isMobile}
          users={users}
          goToProfile={goToProfile}
        />
      ) : (
        <DesktopView
          state={state}
          isMobile={isMobile}
          users={users}
          goToProfile={goToProfile}
        />
      )}
      {/* <Box ref={containerRef}></Box> */}

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={state.loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default SearchUsers;
